import { buildVisibleToolPredicate } from '../constants';
import type { IRainAgentConfig } from '../hooks/scope';

import {
  EAstralInternalTool,
  EAstralUnhandledTool,
  EAstralVisibleTool,
} from './astral2';
import {
  renderGuideApprovalCard,
  renderRequestReviewCard,
} from './renderers/astral2';
import { renderConnectionPickerCard } from './renderers/connection';

/**
 * Behavioral config for Astral's chat, consumed by the Rain core hook via the
 * run-scoped thread adapter. No `planMarkStepToolName`: astral2 does not enable
 * Rain's `plan` source, so there is no Todo card to refresh on a mark.
 */
export const ASTRAL2_AGENT_CONFIG: IRainAgentConfig = {
  isVisibleTool: buildVisibleToolPredicate(Object.values(EAstralVisibleTool)),
  // The Astral repair surface: hidden on purpose, so a dropped call is not
  // drift. `quill_handoff` is deliberately absent — nothing resolves it, so a
  // call arriving IS worth reporting.
  internalTools: new Set<string>(Object.values(EAstralInternalTool)),
  // `quill_handoff` is listed to record that the browser is meant to resolve it.
  // The `is_remote` drift check in `applyToolCallStart` cannot reach it — that
  // runs only for tools `isVisibleTool` admits, and this one is deliberately
  // invisible — so a call goes down the dropped-tool path instead.
  clientResolvedTools: new Set<string>([
    EAstralVisibleTool.RequestConnection,
    EAstralVisibleTool.RequestReview,
    EAstralVisibleTool.RequestGuideApproval,
    EAstralUnhandledTool.QuillHandoff,
  ]),
  toolRenderers: {
    [EAstralVisibleTool.RequestConnection]: renderConnectionPickerCard,
    [EAstralVisibleTool.RequestReview]: renderRequestReviewCard,
    [EAstralVisibleTool.RequestGuideApproval]: renderGuideApprovalCard,
  },
};
